import lessRequire from '../../../config/less-require-resolver';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import renderViewsState from '../../shared/render-views-state';
import Animate from '../../shared/animation';

import Table from '../components/table/auto-trash/main';
import SwitchStats from '../components/switch/main';

lessRequire('modules/statistics/conversions/main.less');

import Calendar from '../../shared/calendar/main';
import Filters from '../../shared/filters/main';

const Main = renderViewsState(props =>
	<Animate>
		<div className="container">
			<div className="container__content goals-wrap">
				<div className="container__content-title">
					<h2 className="font-proxima-nova-bold">{props.intl('Автотреш')}</h2>
					<SwitchStats intl={props.intl} activeTab="autotrash" />
				</div>
				<div className="autotrash_explanation">
					<p><div dangerouslySetInnerHTML={{ __html: props.intl('Автотреш обьяснение 1') }} /></p>
					<ul>
						<li><div dangerouslySetInnerHTML={{ __html: props.intl('Автотреш обьяснение 1.1') }} /></li>
						<li><div dangerouslySetInnerHTML={{ __html: props.intl('Автотреш обьяснение 1.2') }} /></li>
						<li><div dangerouslySetInnerHTML={{ __html: props.intl('Автотреш обьяснение 1.3') }} /></li>
					</ul>
					<p><div dangerouslySetInnerHTML={{ __html: props.intl('Автотреш обьяснение 2') }} /></p>
					<p><div dangerouslySetInnerHTML={{ __html: props.intl('Автотреш обьяснение 3') }} /></p>
					<p>
						<div dangerouslySetInnerHTML={{ __html: props.intl('Автотреш обьяснение 4') }} />
						<div dangerouslySetInnerHTML={{ __html: props.intl('Автотреш обьяснение 5') }} />
					</p>
					<div dangerouslySetInnerHTML={{ __html: props.intl('Автотреш обьяснение 6') }} />
					<div dangerouslySetInnerHTML={{ __html: props.intl('Автотреш обьяснение 7') }} />
				</div>
				<div className="container__content-body">
					<div className="goals-wrap__control">
						<div className="goals-wrap__control-bottom clearfix">
							<Filters {...props} filterApply={props.statisticsFilterApply} />
						</div>
						<div className="goals-wrap__control-bottom clearfix">
							<button className="save-button" onClick={props.autotrashExport}>
							</button>
							<button className="submit-btn" onClick={e => props.statsApply()}>
								{props.intl('Применить')}
							</button>
							<div className="calendar-position">
								<Calendar
									{...props.calendar}
									onInit={props.calendarInit}
									onToggle={props.calendarToggle}
									onChange={props.calendarChange}
									onApply={props.calendarApply}
									intl={props.intl}
								/>
							</div>
						</div>
					</div>
					<Table
						tableRows={props.dataTable}
						{...props}
					/>
				</div>
			</div>
		</div>
	</Animate>
);

export default connect(
	state  => {
		return {
			data: selectors.getData(state),
			isShowedAutoTrash: selectors.getIsShowedAutoTrash(state),
			dataTable: selectors.getTableData(state),
			filters: selectors.getFilters(state),
			appliedFilters: selectors.getAppliedFilters(state),
			progressBar: selectors.getProgressBar(state),
			error: selectors.getError(state),
			calendar: selectors.getCalendar(state),
			intl: selectors.getIntl(state)
		};
	},
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/statistics/ban/main.js